import clsx from 'clsx';
import type { InputHTMLAttributes } from 'react';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'value' | 'onChange'> & {
  label: string;
  value: string | number;
  hint?: string;
  onValueChange: (v: string) => void;
};

export function TextField({ label, value, hint, onValueChange, className, ...rest }: Props) {
  return (
    <label
      className={clsx('flex flex-col gap-1 text-sm', className)}
      {...(hint !== undefined ? { title: hint } : {})}
    >
      {label !== '' && (
        <span className="flex items-center gap-1 text-neutral-400">
          {label}
          {hint !== undefined && (
            <span aria-hidden="true" className="text-neutral-500 text-[10px] cursor-help">?</span>
          )}
        </span>
      )}
      <input
        type="text"
        value={value}
        onChange={(e) => onValueChange(e.target.value)}
        className="bg-neutral-800 text-neutral-100 rounded px-2 py-1 font-mono focus:outline-none focus:ring-2 focus:ring-neutral-500"
        {...rest}
      />
    </label>
  );
}
